import HowItWorks from "./HowItWorks";

export { HowItWorks };
